<template>
<Header hrefTo="#mainView"/>
<Main heading="Sitemap">
  <main-view :isContactPage="true">
    <h2>Categories</h2>
    <ul class="pages-ul main">
      <li><h3><a href="/index.html">Home Page</a></h3></li>
      <li> 
        <h3>About Page</h3>
        <ul>
          <li v-for="page in pages.about" :key="page.name" >
            <a :href="page.path">{{page.name}}</a>
          </li>
        </ul>
      </li>
    <li>
      <h3>Our Work</h3>
      <ul>
        <li v-for="page in pages.work" :key="page.name" >
          <a :href="page.path">{{page.name}}</a>
        </li>
     </ul>
    </li>
   <li>
     <h3>Members</h3>
      <ul>
      <li v-for="page in pages.members" :key="page.name" >
        <a :href="page.path">{{page.name}}</a>
      </li>
    </ul>
   </li>
    <li><h3><a href="/contact.html">Contact Page</a></h3></li>  
    <!-- <li><h3><a href="/contact.html">Accessibility Statement</a></h3></li>  
    <li><h3><a href="/contact.html">Sustainability Report</a></h3></li>   -->

    </ul>
<h2>Pages</h2>
<ul class="pages-ul main">
    <li><h3><a class="link"  href="/index.html">Home</a></h3></li>
      <li><h3><a class="link"  href="/about.html">About</a></h3></li>
      <li><h3><a class="link"  href="/work.html">Our Work</a></h3></li>
      <li><h3><a class="link"  href="/members.html">Members</a></h3></li>
      <li><h3><a class="link"  href="/contact.html">Contact</a></h3></li>
</ul>
<h2>Other Links</h2>
<ul class="pages-ul other">
    <li><a class="link"  href="/accessibility.html">Accessibility Statement</a></li>
      <li><a class="link"  href="/sustainability.html">Sustainability Report</a></li>
      <li><a class="link"  href="/sitemap.html">Sitemap</a></li>
</ul>
  </main-view>
</Main>
<Footer />
</template>

<script>
import { useGtag } from "vue-gtag-next";
import Header from "../../components/Header/_Header.vue";
import Main from "../../components/Main/_Main.vue";
import MainView from "../../components/MainView/_MainView.vue";
import Footer from "../../components/Footer/_Footer";
import pagesData from '../pages.json';

export default {
  name: "Sitemap",
  data(){
    return {
      pages: pagesData,
    }
  },
  components: {
    Header,
    Main,
    MainView,
    Footer,
  },
};
</script>

<style lang="scss">
  @import "./sitemap.scss";
</style>
